import { useMemo } from 'react';
import useSelectInsuranceProfile from '../../../../../hooks/useSelectInsuranceProfile';
import { getInsuranceCarrierCardDisplayProperties } from '../../../../../../../core/util/insurance';

export default (userProfileId: any) => {
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);
  return useMemo(() => {
    if (insuranceProfile && insuranceProfile.insurer_code)
      return getInsuranceCarrierCardDisplayProperties(insuranceProfile.insurer_code);
    return null;
  }, [insuranceProfile]);
};
